import ForumIcon from "@mui/icons-material/Forum";
import { Box } from "@mui/material";
import { PrimaryNavLink } from "@teamworksdev/nav";

// full page path
export const NAV_ORG_MESSAGING_UNITY = "/org/messaging-unity";

const MessageIcon = () => {
  return (
    <Box sx={{ position: "relative" }}>
      <ForumIcon />
    </Box>
  );
};
//IMPORTANT!:
// In order for the MFE to load properly, set VITE_WEB_DOMAIN="localhost:80"
export const unityMessageLink: PrimaryNavLink = {
  to: NAV_ORG_MESSAGING_UNITY,
  name: (
    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>Messages</Box>
  ) as unknown as string,
  icon: <MessageIcon />,
};
